import { useQuery, QueryHookOptions } from '@apollo/client';

import { GET_PUBLIC_CONTENT_GUIDELINE_BY_ID_QUERY } from '@frontend/app/queries';
import { GetPublicContentGuidelineById, GetPublicContentGuidelineByIdVariables } from '@frontend/app/queries/types/GetPublicContentGuidelineById';

type IOptions = QueryHookOptions<GetPublicContentGuidelineById, GetPublicContentGuidelineByIdVariables>;

export const useGetPublicContentGuidelinesById = (options: IOptions = {}) => {
  const { data, loading, error } = useQuery<GetPublicContentGuidelineById, GetPublicContentGuidelineByIdVariables>(
    GET_PUBLIC_CONTENT_GUIDELINE_BY_ID_QUERY,
    options,
  );

  return {
    contentGuideline: data?.guideline,
    isContentGuidelineLoading: loading,
    contentGuidelineError: error,
  };
};
